import { render, staticRenderFns } from "./EquipmentItems.vue?vue&type=template&id=679947de"
import script from "./EquipmentItems.vue?vue&type=script&lang=js"
export * from "./EquipmentItems.vue?vue&type=script&lang=js"
import style0 from "./EquipmentItems.vue?vue&type=style&index=0&id=679947de&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports